import styled from 'styled-components';

export const FileInput = styled.input`
  width: 100%;
`;
